export const colors = ["#ffffff", "#fdfefe", "#fbfefc", "#fafdfb", "#f8fdfa", "#f6fcf8", "#f4fcf7", "#f2fbf6",
                        "#f0fbf5", "#effaf4", "#edfaf4", "#ebf9f3", "#e9f8f2", "#e7f8f1", "#e5f7f1", "#e3f6f0",
                        "#e2f6f0", "#e0f5f0", "#def4ef", "#dcf3ef", "#dbf3ef", "#d9f2ef", "#d7f1ef", "#d6f0ef",
                        "#d4efef", "#d3eeef", "#d1edef", "#d0ecef", "#cfebef", "#cdeaef", "#cce9ef", "#cbe8f0",
                        "#cae7f0", "#c9e5f0", "#c8e4f0", "#c7e3f1", "#c6e1f1", "#c6e0f1", "#c5dff2", "#c4ddf2",
                        "#c4dcf2", "#c3daf2", "#c3d9f3", "#c2d7f3", "#c2d6f3", "#c2d4f3", "#c2d2f3", "#c1d1f3",
                        "#c1cff3", "#c1cdf3", "#c1ccf3", "#c1caf3", "#c2c8f3", "#c2c6f3", "#c2c5f3", "#c2c3f2",
                        "#c3c1f2", "#c3bff2", "#c4bdf1", "#c4bcf1", "#c5baf0", "#c5b8ef", "#c6b6ee", "#c6b4ee",
                        "#c7b2ed", "#c8b1ec", "#c8afea", "#c9ade9", "#caabe8", "#caa9e7", "#cba8e5", "#cca6e4",
                        "#cca4e2", "#cda2e0", "#cea1df", "#cf9fdd", "#cf9ddb", "#d09cd9", "#d09ad7", "#d198d4",
                        "#d297d2", "#d295d0", "#d294ce", "#d392cb", "#d391c9", "#d490c6", "#d48ec3", "#d48dc1",
                        "#d48cbe", "#d48abb", "#d589b8", "#d588b5", "#d487b2", "#d486af", "#d485ac", "#d484a9",
                        "#d383a6", "#d382a3", "#d381a0", "#d2809c", "#d18099", "#d17f96", "#d07e93", "#cf7e8f",
                        "#ce7d8c", "#cd7d89", "#cc7c86", "#ca7c83", "#c97b7f", "#c87b7c", "#c67a79", "#c57a76",
                        "#c37a73", "#c17a70", "#bf796d", "#be796a", "#bc7967", "#b97964", "#b77961", "#b5795e",
                        "#b3795b", "#b17959", "#ae7956", "#ac7954", "#a97951", "#a7794f", "#a4794c", "#a1794a",
                        "#9f7948", "#9c7946", "#997944", "#967a42", "#937a40", "#907a3e", "#8d7a3d", "#8a7a3b",
                        "#877a3a", "#847a38", "#817a37", "#7e7a36", "#7b7a35", "#787b34", "#757b33", "#727b32",
                        "#6f7b31", "#6c7b31", "#697b30", "#667a30", "#637a2f", "#607a2f", "#5d7a2f", "#5a7a2f",
                        "#577a2f", "#54792f", "#51792f", "#4e792f", "#4c792f", "#497830", "#467830", "#447731",
                        "#417731", "#3f7632", "#3c7632", "#3a7533", "#387434", "#357435", "#337335", "#317236",
                        "#2f7137", "#2d7038", "#2b6f39", "#2a6e3a", "#286d3b", "#266c3c", "#256b3d", "#236a3e",
                        "#22693f", "#206840", "#1f6741", "#1e6542", "#1d6443", "#1c6344", "#1b6145", "#1a6046",
                        "#195e47", "#195d48", "#185b48", "#175a49", "#17584a", "#16574b", "#16554b", "#16534c",
                        "#15524c", "#15504d", "#154e4d", "#154d4e", "#154b4e", "#15494e", "#15474e", "#15464e",
                        "#15444f", "#15424e", "#16404e", "#163f4e", "#163d4e", "#163b4e", "#16394d", "#17374d",
                        "#17364c", "#17344c", "#18324b", "#18314a", "#182f49", "#192d48", "#192c47", "#192a46",
                        "#192845", "#1a2744", "#1a2543", "#1a2441", "#1a2240", "#1a213e", "#1b1f3d", "#1b1e3b",
                        "#1b1c3a", "#1b1b38", "#1b1a36", "#1a1835", "#1a1733", "#1a1631", "#1a142f", "#19132d",
                        "#19122b", "#191129", "#181027", "#180f25", "#170e23", "#160d21", "#160c1f", "#150b1d",
                        "#140a1b", "#130919", "#120817", "#110815", "#100713", "#0f0611", "#0e050f", "#0c050e",
                        "#0b040c", "#0a030a", "#080308", "#070206", "#050205", "#030103", "#020102", "#000000"];

// export const colors =['#ffffff',
// '#ffffff',
// '#f9fef9',
// '#f9fef9',
// '#f3fef4',
// '#f3fef4',
// '#eefdee',
// '#eefdee',
// '#e8fde9',
// '#e8fde9',
// '#e2fce3',
// '#e2fce3',
// '#dcfcde',
// '#dcfcde',
// '#d6fbd8',
// '#d6fbd8',
// '#d1fbd3',
// '#d1fbd3',
// '#cbfacd',
// '#cbfacd',
// '#c5fac8',
// '#c5fac8',
// '#bff9c2',
// '#bff9c2',
// '#baf9bd',
// '#baf9bd',
// '#b4f8b7',
// '#b4f8b7',
// '#aef7b2',
// '#aef7b2',
// '#a8f7ac',
// '#a8f7ac',
// '#a2f6a7',
// '#a2f6a7',
// '#9df6a1',
// '#9df6a1',
// '#97f59b',
// '#97f59b',
// '#91f596',
// '#91f596',
// '#8bf490',
// '#8bf490',
// '#85f48b',
// '#85f48b',
// '#80f385',
// '#80f385',
// '#7af380',
// '#7af380',
// '#74f27a',
// '#74f27a',
// '#6ef175',
// '#6ef175',
// '#69f16f',
// '#69f16f',
// '#63f06a',
// '#63f06a',
// '#5df064',
// '#5df064',
// '#57ef5f',
// '#57ef5f',
// '#51ef59',
// '#51ef59',
// '#4cee54',
// '#4cee54',
// '#46ee4e',
// '#46ee4e',
// '#40ed49',
// '#40ed49',
// '#3aed43',
// '#3aed43',
// '#34ec3d',
// '#34ec3d',
// '#2fec38',
// '#2fec38',
// '#29eb32',
// '#29eb32',
// '#23ea2d',
// '#23ea2d',
// '#1dea27',
// '#1dea27',
// '#17e922',
// '#17e922',
// '#12e91c',
// '#12e91c',
// '#0ce817',
// '#0ce817',
// '#09e717',
// '#09e717',
// '#09e51c',
// '#09e51c',
// '#08e321',
// '#08e321',
// '#08e126',
// '#08e126',
// '#08df2b',
// '#08df2b',
// '#08dd30',
// '#08dd30',
// '#08db35',
// '#08db35',
// '#07d93a',
// '#07d93a',
// '#07d73f',
// '#07d73f',
// '#07d544',
// '#07d544',
// '#07d349',
// '#07d349',
// '#07d04e',
// '#07d04e',
// '#06ce53',
// '#06ce53',
// '#06cc58',
// '#06cc58',
// '#06ca5d',
// '#06ca5d',
// '#06c862',
// '#06c862',
// '#06c667',
// '#06c667',
// '#05c46d',
// '#05c46d',
// '#05c272',
// '#05c272',
// '#05c077',
// '#05c077',
// '#05be7c',
// '#05be7c',
// '#04bc81',
// '#04bc81',
// '#04ba86',
// '#04ba86',
// '#04b88b',
// '#04b88b',
// '#04b690',
// '#04b690',
// '#04b495',
// '#04b495',
// '#03b29a',
// '#03b29a',
// '#03b09f',
// '#03b09f',
// '#03aea4',
// '#03aea4',
// '#03aca9',
// '#03aca9',
// '#03aaae',
// '#03aaae',
// '#02a8b3',
// '#02a8b3',
// '#02a5b8',
// '#02a5b8',
// '#02a3bd',
// '#02a3bd',
// '#02a1c3',
// '#02a1c3',
// '#019fc8',
// '#019fc8',
// '#019dcd',
// '#019dcd',
// '#019bd2',
// '#019bd2',
// '#0199d7',
// '#0199d7',
// '#0197dc',
// '#0197dc',
// '#0095e1',
// '#0095e1',
// '#0093e6',
// '#0093e6',
// '#0091eb',
// '#0091eb',
// '#008eeb',
// '#008eeb',
// '#008beb',
// '#008beb',
// '#0088eb',
// '#0088eb',
// '#0084eb',
// '#0084eb',
// '#0081eb',
// '#0081eb',
// '#007eeb',
// '#007eeb',
// '#007beb',
// '#007beb',
// '#0078eb',
// '#0078eb',
// '#0075eb',
// '#0075eb',
// '#0072eb',
// '#0072eb',
// '#006feb',
// '#006feb',
// '#006beb',
// '#006beb',
// '#0068eb',
// '#0068eb',
// '#0065eb',
// '#0065eb',
// '#0062eb',
// '#0062eb',
// '#005feb',
// '#005feb',
// '#005ceb',
// '#005ceb',
// '#0059eb',
// '#0059eb',
// '#0056eb',
// '#0056eb',
// '#0052eb',
// '#0052eb',
// '#004feb',
// '#004feb',
// '#004ceb',
// '#004ceb',
// '#0049eb',
// '#0049eb',
// '#0046eb',
// '#0046eb',
// '#0043eb',
// '#0043eb',
// '#0040eb',
// '#0040eb',
// '#003deb',
// '#003deb',
// '#0039eb',
// '#0039eb',
// '#0036eb',
// '#0036eb',
// '#0033eb',
// '#0033eb',
// '#0030eb',
// '#0030eb',
// '#002deb',
// '#002deb',
// '#002aeb',
// '#002aeb',
// '#0027eb',
// '#0027eb',
// '#0023eb',
// '#0023eb',
// '#0020eb',
// '#0020eb',
// '#001deb',
// '#001deb',
// '#001aeb',
// '#001aeb',
// '#0017eb',
// '#0017eb',
// '#0014eb',
// '#0014eb',
// '#0011eb',
// '#0011eb',
// '#000eeb',
// '#000eeb',
// '#010ceb',
// '#010ceb',
// '#040ceb',
// '#040ceb',
// '#060beb',
// '#060beb',
// '#090beb',
// '#090beb',
// '#0b0beb',
// '#0b0beb',
// '#0e0aeb',
// '#0e0aeb',
// '#100aeb',
// '#100aeb',
// '#130aeb',
// '#130aeb',
// '#150aeb',
// '#150aeb',
// '#1809eb',
// '#1809eb',
// '#1a09eb',
// '#1a09eb',
// '#1d09eb',
// '#1d09eb',
// '#1f08eb',
// '#1f08eb',
// '#2208eb',
// '#2208eb',
// '#2408eb',
// '#2408eb',
// '#2708eb',
// '#2708eb',
// '#2907eb',
// '#2907eb',
// '#2c07eb',
// '#2c07eb',
// '#2e07eb',
// '#2e07eb',
// '#3106eb',
// '#3106eb',
// '#3306eb',
// '#3306eb',
// '#3606eb',
// '#3606eb',
// '#3806eb',
// '#3806eb',
// '#3b05eb',
// '#3b05eb',
// '#3d05eb',
// '#3d05eb',
// '#4005eb',
// '#4005eb',
// '#4205eb',
// '#4205eb',
// '#4504eb',
// '#4504eb',
// '#4704eb',
// '#4704eb',
// '#4a04eb',
// '#4a04eb',
// '#4c03eb',
// '#4c03eb',
// '#4f03eb',
// '#4f03eb',
// '#5103eb',
// '#5103eb',
// '#5403eb',
// '#5403eb',
// '#5602eb',
// '#5602eb',
// '#5902eb',
// '#5902eb',
// '#5b02eb',
// '#5b02eb',
// '#5e01eb',
// '#5e01eb',
// '#6001eb',
// '#6001eb',
// '#6301eb',
// '#6301eb',
// '#6501eb',
// '#6501eb',
// '#6800eb',
// '#6800eb',
// '#6a00eb',
// '#6a00eb',
// '#6d00ea',
// '#6d00ea',
// '#7000e8',
// '#7000e8',
// '#7300e7',
// '#7300e7',
// '#7600e6',
// '#7600e6',
// '#7900e5',
// '#7900e5',
// '#7c00e3',
// '#7c00e3',
// '#7f00e2',
// '#7f00e2',
// '#8200e1',
// '#8200e1',
// '#8500df',
// '#8500df',
// '#8800de',
// '#8800de',
// '#8b00dd',
// '#8b00dd',
// '#8e00db',
// '#8e00db',
// '#9100da',
// '#9100da',
// '#9400d9',
// '#9400d9',
// '#9800d8',
// '#9800d8',
// '#9b00d6',
// '#9b00d6',
// '#9e00d5',
// '#9e00d5',
// '#a100d4',
// '#a100d4',
// '#a400d2',
// '#a400d2',
// '#a700d1',
// '#a700d1',
// '#aa00d0',
// '#aa00d0',
// '#ad00cf',
// '#ad00cf',
// '#b000cd',
// '#b000cd',
// '#b300cc',
// '#b300cc',
// '#b600cb',
// '#b600cb',
// '#b900c9',
// '#b900c9',
// '#bc00c8',
// '#bc00c8',
// '#bf00c7',
// '#bf00c7',
// '#c200c5',
// '#c200c5',
// '#c500c4',
// '#c500c4',
// '#c800c3',
// '#c800c3',
// '#cb00c2',
// '#cb00c2',
// '#ce00c0',
// '#ce00c0',
// '#d100bf',
// '#d100bf',
// '#d400be',
// '#d400be',
// '#d700bc',
// '#d700bc',
// '#da00bb',
// '#da00bb',
// '#dd00ba',
// '#dd00ba',
// '#e000b9',
// '#e000b9',
// '#e300b7',
// '#e300b7',
// '#e600b6',
// '#e600b6',
// '#e900b5',
// '#e900b5',
// '#eb00b2',
// '#eb00b2',
// '#eb01ae',
// '#eb01ae',
// '#eb01a9',
// '#eb01a9',
// '#eb02a5',
// '#eb02a5',
// '#eb02a1',
// '#eb02a1',
// '#eb039d',
// '#eb039d',
// '#eb0398',
// '#eb0398',
// '#eb0494',
// '#eb0494',
// '#eb0490',
// '#eb0490',
// '#eb048c',
// '#eb048c',
// '#eb0588',
// '#eb0588',
// '#eb0583',
// '#eb0583',
// '#eb067f',
// '#eb067f',
// '#eb067b',
// '#eb067b',
// '#eb0777',
// '#eb0777',
// '#eb0772',
// '#eb0772',
// '#eb086e',
// '#eb086e',
// '#eb086a',
// '#eb086a',
// '#eb0966',
// '#eb0966',
// '#eb0961',
// '#eb0961',
// '#eb0a5d',
// '#eb0a5d',
// '#eb0a59',
// '#eb0a59',
// '#eb0b55',
// '#eb0b55',
// '#eb0b50',
// '#eb0b50',
// '#eb0c4c',
// '#eb0c4c',
// '#eb0c48',
// '#eb0c48',
// '#eb0c44',
// '#eb0c44',
// '#eb0d40',
// '#eb0d40',
// '#eb0d3b',
// '#eb0d3b',
// '#eb0e37',
// '#eb0e37',
// '#eb0e33',
// '#eb0e33',
// '#eb0f2f',
// '#eb0f2f',
// '#eb0f2a',
// '#eb0f2a',
// '#eb1026',
// '#eb1026',
// '#eb1022',
// '#eb1022',
// '#eb111e',
// '#eb111e',
// '#eb1119',
// '#eb1119',
// '#eb1215',
// '#eb1215',
// '#eb1211',
// '#eb1211',
// '#eb130d',
// '#eb130d',
// '#eb1308',
// '#eb1308',
// '#eb1404',
// '#eb1404',
// '#eb1400',
// '#eb1400'];

// export const colors = ['#ffe3e3',
// '#ffe3e3',
// '#fce4e1',
// '#fce4e1',
// '#f9e4e0',
// '#f9e4e0',
// '#f6e5de',
// '#f6e5de',
// '#f3e6dc',
// '#f3e6dc',
// '#f0e6db',
// '#f0e6db',
// '#eee7d9',
// '#eee7d9',
// '#ebe8d7',
// '#ebe8d7',
// '#e8e8d6',
// '#e8e8d6',
// '#e5e9d4',
// '#e5e9d4',
// '#e2ead2',
// '#e2ead2',
// '#dfebd1',
// '#dfebd1',
// '#dcebcf',
// '#dcebcf',
// '#d9eccd',
// '#d9eccd',
// '#d6edcc',
// '#d6edcc',
// '#d3edca',
// '#d3edca',
// '#d0eec8',
// '#d0eec8',
// '#ceefc7',
// '#ceefc7',
// '#cbefc5',
// '#cbefc5',
// '#c8f0c3',
// '#c8f0c3',
// '#c5f1c2',
// '#c5f1c2',
// '#c2f1c0',
// '#c2f1c0',
// '#bff2be',
// '#bff2be',
// '#bcf3bc',
// '#bcf3bc',
// '#b9f3bb',
// '#b9f3bb',
// '#b6f4b9',
// '#b6f4b9',
// '#b3f5b7',
// '#b3f5b7',
// '#b0f6b6',
// '#b0f6b6',
// '#aef6b4',
// '#aef6b4',
// '#abf7b2',
// '#abf7b2',
// '#a8f8b1',
// '#a8f8b1',
// '#a5f8af',
// '#a5f8af',
// '#a2f9ad',
// '#a2f9ad',
// '#9ffaac',
// '#9ffaac',
// '#9cfaaa',
// '#9cfaaa',
// '#99fba8',
// '#99fba8',
// '#96fca7',
// '#96fca7',
// '#97fba4',
// '#97fba4',
// '#99faa2',
// '#99faa2',
// '#9cf89f',
// '#9cf89f',
// '#9ff79d',
// '#9ff79d',
// '#a2f59a',
// '#a2f59a',
// '#a4f497',
// '#a4f497',
// '#a7f395',
// '#a7f395',
// '#aaf192',
// '#aaf192',
// '#adf08f',
// '#adf08f',
// '#afee8d',
// '#afee8d',
// '#b2ed8a',
// '#b2ed8a',
// '#b5eb88',
// '#b5eb88',
// '#b8ea85',
// '#b8ea85',
// '#bae982',
// '#bae982',
// '#bde780',
// '#bde780',
// '#c0e67d',
// '#c0e67d',
// '#c2e47a',
// '#c2e47a',
// '#c5e378',
// '#c5e378',
// '#c8e175',
// '#c8e175',
// '#cbe072',
// '#cbe072',
// '#cddf70',
// '#cddf70',
// '#d0dd6d',
// '#d0dd6d',
// '#d3dc6b',
// '#d3dc6b',
// '#d6da68',
// '#d6da68',
// '#d8d965',
// '#d8d965',
// '#dbd763',
// '#dbd763',
// '#ded660',
// '#ded660',
// '#e1d55d',
// '#e1d55d',
// '#e3d35b',
// '#e3d35b',
// '#e6d258',
// '#e6d258',
// '#e9d055',
// '#e9d055',
// '#eccf53',
// '#eccf53',
// '#eece50',
// '#eece50',
// '#f1cc4e',
// '#f1cc4e',
// '#f4cb4b',
// '#f4cb4b',
// '#f7c948',
// '#f7c948',
// '#f9c846',
// '#f9c846',
// '#f9c546',
// '#f9c546',
// '#f9c346',
// '#f9c346',
// '#f9c046',
// '#f9c046',
// '#f9be46',
// '#f9be46',
// '#f9bb46',
// '#f9bb46',
// '#f9b946',
// '#f9b946',
// '#f9b646',
// '#f9b646',
// '#f9b446',
// '#f9b446',
// '#f9b146',
// '#f9b146',
// '#f9af46',
// '#f9af46',
// '#f9ac46',
// '#f9ac46',
// '#f9aa46',
// '#f9aa46',
// '#f9a846',
// '#f9a846',
// '#f9a546',
// '#f9a546',
// '#f9a346',
// '#f9a346',
// '#f9a046',
// '#f9a046',
// '#f99e46',
// '#f99e46',
// '#f99b46',
// '#f99b46',
// '#f99946',
// '#f99946',
// '#f99646',
// '#f99646',
// '#f99446',
// '#f99446',
// '#f99146',
// '#f99146',
// '#f98f46',
// '#f98f46',
// '#f98c46',
// '#f98c46',
// '#f98a46',
// '#f98a46',
// '#f98746',
// '#f98746',
// '#f98546',
// '#f98546',
// '#f98246',
// '#f98246',
// '#f98046',
// '#f98046',
// '#f97e46',
// '#f97e46',
// '#f97b46',
// '#f97b46',
// '#f97946',
// '#f97946',
// '#f97646',
// '#f97646',
// '#f97446',
// '#f97446',
// '#f97146',
// '#f97146',
// '#f96f46',
// '#f96f46',
// '#f96c45',
// '#f96c45',
// '#f96943',
// '#f96943',
// '#f96641',
// '#f96641',
// '#f9633f',
// '#f9633f',
// '#f9603d',
// '#f9603d',
// '#f95d3b',
// '#f95d3b',
// '#fa5a39',
// '#fa5a39',
// '#fa5737',
// '#fa5737',
// '#fa5435',
// '#fa5435',
// '#fa5133',
// '#fa5133',
// '#fa4e31',
// '#fa4e31',
// '#fa4b2f',
// '#fa4b2f',
// '#fa482e',
// '#fa482e',
// '#fa452c',
// '#fa452c',
// '#fa422a',
// '#fa422a',
// '#fa3f28',
// '#fa3f28',
// '#fa3c26',
// '#fa3c26',
// '#fa3924',
// '#fa3924',
// '#fb3522',
// '#fb3522',
// '#fb3220',
// '#fb3220',
// '#fb2f1e',
// '#fb2f1e',
// '#fb2c1c',
// '#fb2c1c',
// '#fb291a',
// '#fb291a',
// '#fb2618',
// '#fb2618',
// '#fb2317',
// '#fb2317',
// '#fb2015',
// '#fb2015',
// '#fb1d13',
// '#fb1d13',
// '#fb1a11',
// '#fb1a11',
// '#fb170f',
// '#fb170f',
// '#fb140d',
// '#fb140d',
// '#fc110b',
// '#fc110b',
// '#fc0e09',
// '#fc0e09',
// '#fc0b07',
// '#fc0b07',
// '#fc0805',
// '#fc0805',
// '#fc0503',
// '#fc0503',
// '#fc0201',
// '#fc0201',
// '#fa0101',
// '#fa0101',
// '#f50606',
// '#f50606',
// '#ef0a0b',
// '#ef0a0b',
// '#e90e10',
// '#e90e10',
// '#e31315',
// '#e31315',
// '#de171a',
// '#de171a',
// '#d81c1e',
// '#d81c1e',
// '#d22023',
// '#d22023',
// '#cc2428',
// '#cc2428',
// '#c6292d',
// '#c6292d',
// '#c12d32',
// '#c12d32',
// '#bb3237',
// '#bb3237',
// '#b5363b',
// '#b5363b',
// '#af3a40',
// '#af3a40',
// '#aa3f45',
// '#aa3f45',
// '#a4434a',
// '#a4434a',
// '#9e484f',
// '#9e484f',
// '#984c54',
// '#984c54',
// '#935058',
// '#935058',
// '#8d555d',
// '#8d555d',
// '#875962',
// '#875962',
// '#815d67',
// '#815d67',
// '#7c626c',
// '#7c626c',
// '#766671',
// '#766671',
// '#706b75',
// '#706b75',
// '#6a6f7a',
// '#6a6f7a',
// '#64737f',
// '#64737f',
// '#5f7884',
// '#5f7884',
// '#597c89',
// '#597c89',
// '#53818d',
// '#53818d',
// '#4d8592',
// '#4d8592',
// '#488997',
// '#488997',
// '#428e9c',
// '#428e9c',
// '#3c92a1',
// '#3c92a1',
// '#3697a6',
// '#3697a6',
// '#319baa',
// '#319baa',
// '#2b9faf',
// '#2b9faf',
// '#2c9eaf',
// '#2c9eaf',
// '#2e9bae',
// '#2e9bae',
// '#3098ad',
// '#3098ad',
// '#3296ac',
// '#3296ac',
// '#3493ab',
// '#3493ab',
// '#3690aa',
// '#3690aa',
// '#388ea9',
// '#388ea9',
// '#3a8ba8',
// '#3a8ba8',
// '#3c88a7',
// '#3c88a7',
// '#3f86a6',
// '#3f86a6',
// '#4183a5',
// '#4183a5',
// '#4380a4',
// '#4380a4',
// '#457ea3',
// '#457ea3',
// '#477ba2',
// '#477ba2',
// '#4978a1',
// '#4978a1',
// '#4b769f',
// '#4b769f',
// '#4d739e',
// '#4d739e',
// '#4f709d',
// '#4f709d',
// '#516e9c',
// '#516e9c',
// '#536b9b',
// '#536b9b',
// '#56689a',
// '#56689a',
// '#586699',
// '#586699',
// '#5a6398',
// '#5a6398',
// '#5c6097',
// '#5c6097',
// '#5e5e96',
// '#5e5e96',
// '#605b95',
// '#605b95',
// '#625894',
// '#625894',
// '#645693',
// '#645693',
// '#665392',
// '#665392',
// '#685091',
// '#685091',
// '#6a4e90',
// '#6a4e90',
// '#6c4b8f',
// '#6c4b8f',
// '#6f498e',
// '#6f498e',
// '#71468d',
// '#71468d',
// '#73438c',
// '#73438c',
// '#75418b',
// '#75418b',
// '#763f8a',
// '#763f8a',
// '#754088',
// '#754088',
// '#744187',
// '#744187',
// '#734186',
// '#734186',
// '#724285',
// '#724285',
// '#714384',
// '#714384',
// '#704383',
// '#704383',
// '#6f4482',
// '#6f4482',
// '#6e4581',
// '#6e4581',
// '#6d4580',
// '#6d4580',
// '#6c467f',
// '#6c467f',
// '#6b477e',
// '#6b477e',
// '#6a487d',
// '#6a487d',
// '#69487c',
// '#69487c',
// '#69497b',
// '#69497b',
// '#684a79',
// '#684a79',
// '#674a78',
// '#674a78',
// '#664b77',
// '#664b77',
// '#654c76',
// '#654c76',
// '#644c75',
// '#644c75',
// '#634d74',
// '#634d74',
// '#624e73',
// '#624e73',
// '#614e72',
// '#614e72',
// '#604f71',
// '#604f71',
// '#5f5070',
// '#5f5070',
// '#5e506f',
// '#5e506f',
// '#5d516e',
// '#5d516e',
// '#5c526d',
// '#5c526d',
// '#5b536c',
// '#5b536c',
// '#5b536a',
// '#5b536a',
// '#5a5469',
// '#5a5469',
// '#595568',
// '#595568',
// '#585567',
// '#585567',
// '#575666',
// '#575666',
// '#565765',
// '#565765',
// '#555764',
// '#555764',
// '#545863',
// '#545863'];
// ['#ffffff',
// '#fcfffd',
// '#f9fefb',
// '#f6fef9',
// '#f3fdf7',
// '#f0fdf5',
// '#edfcf3',
// '#eafcf1',
// '#e7fcef',
// '#e4fbed',
// '#e1fbeb',
// '#defae8',
// '#dbfae6',
// '#d8f9e4',
// '#d5f9e2',
// '#d1f9e0',
// '#cef8de',
// '#cbf8dc',
// '#c8f7da',
// '#c5f7d8',
// '#c2f7d6',
// '#bff6d4',
// '#bcf6d2',
// '#b9f5d0',
// '#b6f5ce',
// '#b3f4cc',
// '#b0f4ca',
// '#adf4c8',
// '#aaf3c6',
// '#a7f3c4',
// '#a4f2c2',
// '#a1f2c0',
// '#9ef1bd',
// '#9bf1bb',
// '#98f1b9',
// '#95f0b7',
// '#92f0b5',
// '#8fefb3',
// '#8cefb1',
// '#89eeaf',
// '#86eead',
// '#83eeab',
// '#80eda9',
// '#7eeda7',
// '#7eeca6',
// '#7eeca5',
// '#7eeba4',
// '#7eeba2',
// '#7eeba1',
// '#7eeaa0',
// '#7dea9e',
// '#7de99d',
// '#7de99c',
// '#7de89b',
// '#7de899',
// '#7de798',
// '#7de797',
// '#7de796',
// '#7de694',
// '#7de693',
// '#7de592',
// '#7de590',
// '#7de48f',
// '#7de48e',
// '#7ce38d',
// '#7ce38b',
// '#7ce28a',
// '#7ce289',
// '#7ce288',
// '#7ce186',
// '#7ce185',
// '#7ce084',
// '#7ce083',
// '#7cdf81',
// '#7cdf80',
// '#7cde7f',
// '#7cde7d',
// '#7cde7c',
// '#7bdd7b',
// '#7bdd7a',
// '#7bdc78',
// '#7bdc77',
// '#7bdb76',
// '#7bdb75',
// '#7bda73',
// '#7bda72',
// '#7ed870',
// '#81d66f',
// '#83d46d',
// '#86d26b',
// '#89cf6a',
// '#8ccd68',
// '#8ecb66',
// '#91c965',
// '#94c763',
// '#97c561',
// '#99c360',
// '#9cc15e',
// '#9fbe5c',
// '#a2bc5b',
// '#a4ba59',
// '#a7b857',
// '#aab656',
// '#adb454',
// '#afb252',
// '#b2b051',
// '#b5ae4f',
// '#b8ab4d',
// '#baa94c',
// '#bda74a',
// '#c0a548',
// '#c3a347',
// '#c5a145',
// '#c89f43',
// '#cb9d42',
// '#ce9a40',
// '#d0983e',
// '#d3963d',
// '#d6943b',
// '#d99239',
// '#db9038',
// '#de8e36',
// '#e18c34',
// '#e48a33',
// '#e68731',
// '#e9852f',
// '#ec832e',
// '#ef812c',
// '#f07f2b',
// '#f07d2c',
// '#f07b2d',
// '#f0792d',
// '#f0772e',
// '#ef752e',
// '#ef732f',
// '#ef7130',
// '#ef6f30',
// '#ef6d31',
// '#ef6b31',
// '#ef6a32',
// '#ef6833',
// '#ef6633',
// '#ef6434',
// '#ef6234',
// '#ee6035',
// '#ee5e36',
// '#ee5c36',
// '#ee5a37',
// '#ee5838',
// '#ee5638',
// '#ee5439',
// '#ee5239',
// '#ee503a',
// '#ee4e3b',
// '#ee4c3b',
// '#ed4a3c',
// '#ed483c',
// '#ed463d',
// '#ed443e',
// '#ed423e',
// '#ed413f',
// '#ed3f3f',
// '#ed3d40',
// '#ed3b41',
// '#ed3941',
// '#ec3742',
// '#ec3543',
// '#ec3343',
// '#ec3144',
// '#ec2f44',
// '#ec2d45',
// '#ea2c45',
// '#e82b44',
// '#e62a44',
// '#e42943',
// '#e22843',
// '#e02742',
// '#de2642',
// '#dc2541',
// '#da2441',
// '#d82341',
// '#d62240',
// '#d42140',
// '#d2203f',
// '#d01f3f',
// '#ce1e3e',
// '#cc1d3e',
// '#ca1c3d',
// '#c81b3d',
// '#c61a3d',
// '#c4193c',
// '#c2183c',
// '#bf173b',
// '#bd163b',
// '#bb153a',
// '#b9143a',
// '#b71339',
// '#b51239',
// '#b31138',
// '#b11038',
// '#af0f38',
// '#ad0e37',
// '#ab0d37',
// '#a90c36',
// '#a70b36',
// '#a50a35',
// '#a30935',
// '#a10834',
// '#9f0734',
// '#9d0634',
// '#9b0533',
// '#990433',
// '#970332',
// '#950333',
// '#940434',
// '#920536',
// '#900637',
// '#8f0739',
// '#8d083a',
// '#8c093c',
// '#8a093d',
// '#880a3f',
// '#870b40',
// '#850c42',
// '#840d43',
// '#820e45',
// '#800e46',
// '#7f0f47',
// '#7d1049',
// '#7c114a',
// '#7a124c',
// '#78134d',
// '#77144f',
// '#751450',
// '#741552',
// '#721653',
// '#701755',
// '#6f1856',
// '#6d1958',
// '#6c1959',
// '#6a1a5b',
// '#681b5c',
// '#671c5e',
// '#651d5f',
// '#641e61',
// '#621f62',
// '#601f64',
// '#5f2065',
// '#5d2167',
// '#5c2268',
// '#5a236a',
// '#58246b',
// '#57246d',
// '#55256e',
// '#542670',
// '#522771'];